import { PurchaseMortgageCalculatorForm } from '../../types/calculator'
import { getMaximumPurchasePrice } from '../getMaxPurchasePrice'
import { parseFormattedNumber } from '../number'
import { CalculatorStore } from './calculatorStore'

class PurchaseMorgageCalculatorStore extends CalculatorStore<PurchaseMortgageCalculatorForm> {
  id = 'purchase'

  calculateResult = (formValues: PurchaseMortgageCalculatorForm) => {
    const params = this.mapFormValues(formValues)

    const desiredPropertyPrice = parseFormattedNumber(formValues.purchasePrice)

    const result = getMaximumPurchasePrice(
      {
        ...params,
        downPayment: parseFormattedNumber(formValues.downPayment),
      },
      desiredPropertyPrice,
    )

    return result
  }
}

export const purchaseMortgageCalculatorStore = new PurchaseMorgageCalculatorStore()
